import { jsx } from 'react/jsx-runtime';

const Image = (props) => /* @__PURE__ */ jsx("img", {
  /**
   * Keeping `loading` before `src` is intentional because React updates
   * props in order which causes Safari/Firefox to not lazy load properly.
   * See https://github.com/facebook/react/issues/25883
   */
  loading: props.loading,
  src: props.src,
  alt: props.alt ?? "",
  role: props.role ?? "img",
  ...props
});

export { Image as default };
//# sourceMappingURL=Image.js.map
